import mediaUrlProcessor from './MediaUrlProcessor'

export default function adaptStories(rawData) {
    if (!rawData.length) {
        return rawData;
    }
    return rawData.map((data, index) => {
        const result = {
            thumb: null,
            meta: {
                title: `story #${index + 1}`,
                source: ''
            },
            sd: {
                url: null
            },
            url: []
        };

        if (data.image_versions2) {
            result.thumb = data.image_versions2.candidates[0].url_wrapped || mediaUrlProcessor.getPreviewUrl(
                data.image_versions2.candidates[0].url,
                data.image_versions2.candidates[0].url_signature
            )

            result.url = data.image_versions2.candidates.map(version => ({
                ext: 'png',
                name: 'PNG',
                type: 'png',
                quality: version.width,
                url: version.url_downloadable || mediaUrlProcessor.getDownloadableUrl(
                    version.url,
                    version.url_signature
                )
            }))
        }

        if (data.video_versions?.length) {
            result.sd.url = data.video_versions[0].url_wrapped || mediaUrlProcessor.getDownloadableUrl(
                data.video_versions[0].url,
                data.video_versions[0].url_signature
            );

            result.url = data.video_versions.map(version => ({
                ext: 'mp4',
                name: 'MP4',
                type: 'mp4',
                quality: version.width,
                url: version.url_downloadable || mediaUrlProcessor.getDownloadableUrl(
                    version.url,
                    version.url_signature
                )
            }))

        }

        result.url.sort((a, b) => {
            if (a.type === 'mp4' && b.type !== 'mp4') {
                return -1;
            } else if (a.type !== 'mp4' && b.type === 'mp4') {
                return 1;
            } else {
                return a.type.localeCompare(b.type);
            }
        })

        return result;
    }).filter(el => el.url.length)
}
